const UPDATE_AVATAR = `
  mutation UpdateAvatar($input: updateUserProfileInput!) {
    me {
      updateUserProfile(input: $input) {
        image {
          id
          url(width: 60, height: 60)
        }
      }
    }
  }
`;

export default UPDATE_AVATAR;
